import { ErrorBox, Loader } from "@tfg/ui"
import { Navigate, Outlet } from "react-router-dom"
import { useFindFeatureFlagByName } from "~/gen/api"
import { useTranslation } from "react-i18next"

export type FeatureFlagGuardProps = {
  featureFlagName: string
  redirectTo?: string
}
export const FeatureFlagGuard = ({
  featureFlagName,
  redirectTo = "/login",
}: FeatureFlagGuardProps) => {
  const { t } = useTranslation()
  const {
    isLoading,
    data: featureFlag,
    isError,
    error,
  } = useFindFeatureFlagByName(featureFlagName)
  const isEnabled = featureFlag?.data?.state
  if (isLoading) return <Loader fullPage />

  if (isError) {
    return <ErrorBox title={t("dataLoad.error.title")} error={error} />
  }

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />
  }
  return <Outlet />
}
